import './modal-change-password.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faClose } from '@fortawesome/free-solid-svg-icons'
import Button from '../button/button';
import Input from '../input/input';
import { useState, useEffect, useCallback } from 'react';
import TranslateService from '../../services/translate-service';
import ModalTemplate from '../modal-template/modal-template';
import AuthService from '../../services/auth-service';
import LocalStorage from '../../services/local-storage';
import { SESSION, LANGUAGE } from '../../constants';

export default function ModalChangePassword(props) {

    const [session] = useState(LocalStorage.get(SESSION));
    const [language] = useState(LocalStorage.get(LANGUAGE));

    const [errorCurrentPassword, setErrorCurrentPassword] = useState(false);
    const [errorNewPassword, setErrorNewPassword] = useState(false);
    const [errorConfirmPassword, setErrorConfirmPassword] = useState(false);

    const [ruleLength, setRuleLength] = useState(false);
    const [ruleCapital, setRuleCapital] = useState(false);
    const [ruleNumber, setRuleNumber] = useState(false);
    const [ruleSymbol, setRuleSymbol] = useState(false);

    const [currentPassword, setCurrentPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');

    const [isValidForm, setIsValidForm] = useState(false);


    const setPassword = async () => {
        try {
            await AuthService.setPassword(session._id, currentPassword, newPassword);
            props.onClose();
        } catch (error) {
            if (error[language]) {
                setErrorCurrentPassword(error[language]);
            } else {
                setErrorCurrentPassword(error || 'Unknown error');
            }
        }
    }

    const isValidLength = useCallback(() => {
        return newPassword.trim().length >= 8;
    }, [newPassword])

    const isValidUpperCharacter = useCallback(() => {
        const regExp = new RegExp('[A-Z]');
        return regExp.test(newPassword);
    }, [newPassword])

    const isValidDigit = useCallback(() => {
        const regExp = new RegExp('[0-9]');
        return regExp.test(newPassword);
    }, [newPassword])

    const isValidSpecialCharacter = useCallback(() => {
        const regExp = new RegExp('[|@#¿?¡!$]');
        return regExp.test(newPassword);
    }, [newPassword])

    useEffect(() => {
        const isMatch = newPassword !== confirmPassword;

        setErrorConfirmPassword(isMatch);
        setIsValidForm(currentPassword && newPassword && confirmPassword && !isMatch)
    }, [currentPassword, newPassword, confirmPassword]);

    useEffect(() => {
        setRuleLength(isValidLength());
        setRuleCapital(isValidUpperCharacter());
        setRuleNumber(isValidDigit());
        setRuleSymbol(isValidSpecialCharacter());
    }, [newPassword, isValidDigit, isValidLength, isValidSpecialCharacter, isValidUpperCharacter]);


    useEffect(() => {
        document.getElementsByTagName('body')[0].style.overflow = props.isOpen ? 'hidden' : 'auto';

        if (!props.isOpen) {
            setErrorCurrentPassword(false);
            setErrorNewPassword(false);
            setErrorConfirmPassword(false);
            setRuleLength(false);
            setRuleCapital(false);
            setRuleNumber(false);
            setRuleSymbol(false);
            setCurrentPassword('');
            setNewPassword('');
            setConfirmPassword('');
            setIsValidForm(false);
        }
    }, [props.isOpen]);

    return (
        <ModalTemplate isOpen={props.isOpen}>
            <div className='flex items-center mb-[29px]'>
                <div className='heading-h6 grow'>{TranslateService.get('settings.modal.password.title')}</div>
                <div>
                    <button className='btn-close ' onClick={props.onClose}>
                        <FontAwesomeIcon icon={faClose} />
                    </button>
                </div>
            </div>

            <div className=''>
                <Input value={currentPassword} onChange={(event) => setCurrentPassword(event.target.value)} className="mb-6" type='password' label={TranslateService.get('settings.modal.password.current')} isInvalid={errorCurrentPassword} feedback={TranslateService.get('settings.modal.password.current.error')} />

                <p>{TranslateService.get('settings.modal.password.rule.title')}</p>
                <ul className='pl-10 mb-6'>
                    <li className={'list-disc text-sm ' + (ruleLength ? 'text-[#00cc88]' : 'text-error-default')} >{TranslateService.get('settings.modal.password.rule.length')}</li>
                    <li className={'list-disc text-sm ' + (ruleCapital ? 'text-[#00cc88]' : 'text-error-default')} >{TranslateService.get('settings.modal.password.rule.capital')}</li>
                    <li className={'list-disc text-sm ' + (ruleNumber ? 'text-[#00cc88]' : 'text-error-default')} >{TranslateService.get('settings.modal.password.rule.number')}</li>
                    <li className={'list-disc text-sm ' + (ruleSymbol ? 'text-[#00cc88]' : 'text-error-default')} >{TranslateService.get('settings.modal.password.rule.symbol')}</li>
                </ul>
                <Input value={newPassword} onChange={(event) => setNewPassword(event.target.value)} className="mb-6" type='password' label={TranslateService.get('settings.modal.password.password')} isInvalid={errorNewPassword} feedback={TranslateService.get('settings.modal.password.password.error')} />
                <Input value={confirmPassword} onChange={(event) => setConfirmPassword(event.target.value)} className="" type='password' label={TranslateService.get('settings.modal.password.confirm')} isInvalid={errorConfirmPassword} feedback={TranslateService.get('settings.modal.password.confirm.error')} />

                <div className='text-center mt-11' >
                    <Button className='small' disabled={!isValidForm || !ruleLength || !ruleCapital || !ruleNumber || !ruleSymbol} onClick={setPassword}>
                        {TranslateService.get('settings.modal.password.btn')}
                    </Button>
                </div>
            </div>
        </ModalTemplate>
    )
}